import React from 'react';

import { useSelector } from '@datagrid/state';

import { FormBuilder, type FormBuilderProps } from '@tf/form-builder';

import { useClusterId } from '@/core/appMeta';
import { useCurrentUser } from '@/core/hooks';
import { appStore } from '@/core/stores';

export const AppFormBuilder: React.FC<
	Omit<FormBuilderProps, 'apiConfig' | 'defs'> & { fieldFilters?: string[] }
> = (props) => {
	const defs = useSelector(() => appStore.defs.peek());
	const { firstName, lastName } = useCurrentUser();
	const clusterId = useClusterId();

	if (Object.keys(defs.structs).length === 0) {
		return null;
	}

	return (
		<FormBuilder
			{...props}
			disableAutocomplete
			apiConfig={{
				username: `${firstName} ${lastName}`,
				clusterId,
			}}
			defs={{
				structs: defs.structs,
				options: defs.options,
			}}
		/>
	);
};
